"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../..");

var S = _interopRequireWildcard(require("./Pagination.style"));

var _Pagination2 = require("./Pagination.helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.258 7.608a.952.952 0 0 1 .047-1.351.964.964 0 0 1 1.358.047l7.079 7.544a.952.952 0 0 1 0 1.304l-7.079 7.544a.964.964 0 0 1-1.358.047.952.952 0 0 1-.047-1.35l6.467-6.893-6.467-6.892z"
  }));
};

ArrowRightIcon.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.742 7.608a.952.952 0 0 0-.047-1.351.964.964 0 0 0-1.358.047l-7.079 7.544a.952.952 0 0 0 0 1.304l7.079 7.544a.964.964 0 0 0 1.358.047.952.952 0 0 0 .047-1.35L11.275 14.5l6.467-6.892z"
  }));
};

ArrowLeftIcon.defaultProps = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};

var SkipBackwardIcon = function SkipBackwardIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.742 7.108a.952.952 0 0 0-.047-1.351.964.964 0 0 0-1.358.047l-7.079 7.544a.952.952 0 0 0 0 1.304l7.079 7.544a.964.964 0 0 0 1.358.047.952.952 0 0 0 .047-1.35L14.275 14l6.467-6.892zM8.667 21.792V6.208c0-.39-.373-.708-.834-.708-.46 0-.833.317-.833.708v15.584c0 .39.373.708.833.708.46 0 .834-.317.834-.708z"
  }));
};

SkipBackwardIcon.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};

var SkipForwardIcon = function SkipForwardIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.258 20.892a.952.952 0 0 0 .047 1.351c.388.36.996.34 1.358-.047l7.079-7.544a.952.952 0 0 0 0-1.304L8.663 5.804a.964.964 0 0 0-1.358-.047.952.952 0 0 0-.047 1.35L13.725 14l-6.467 6.892zM20.667 21.792V6.208c0-.39-.373-.708-.834-.708-.46 0-.833.317-.833.708v15.584c0 .39.373.708.833.708.46 0 .834-.317.834-.708z"
  }));
};

SkipForwardIcon.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};

var Pagination = function Pagination(_ref) {
  var page = _ref.page,
      total = _ref.total,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["page", "total", "onChange"]);

  var _useState = (0, _react.useState)((0, _Pagination2.configVisible)()),
      _useState2 = _slicedToArray(_useState, 2),
      visiblePages = _useState2[0],
      setVisiblePages = _useState2[1];

  (0, _Pagination2.resizeChangeHandler)(setVisiblePages);

  var handleChange = function handleChange(page) {
    onChange(page);
  };

  return /*#__PURE__*/_react["default"].createElement(S.Pagination, _extends({
    "aria-label": "navega\xE7\xE3o por pagina\xE7\xE3o"
  }, props), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_.IconButton, {
    "aria-label": "Ir para a primeira p\xE1gina",
    variant: "text",
    onClick: function onClick() {
      return handleChange(1);
    },
    disabled: page === 1,
    small: true
  }, /*#__PURE__*/_react["default"].createElement(SkipBackwardIcon, null))), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_.IconButton, {
    "aria-label": "Ir para a p\xE1gina anterior",
    variant: "text",
    onClick: function onClick() {
      return handleChange(page - 1);
    },
    disabled: page === 1,
    small: true
  }, /*#__PURE__*/_react["default"].createElement(ArrowLeftIcon, null))), (0, _Pagination2.getVisiblePages)({
    page: page,
    total: total,
    visiblePages: visiblePages
  }).map(function (index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_.IconButton, {
      "aria-label": "Ir para a p\xE1gina ".concat(index),
      variant: index === page ? 'secondary' : 'text',
      onClick: function onClick() {
        return handleChange(index);
      },
      small: true
    }, index));
  }), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_.IconButton, {
    "aria-label": "Ir para a pr\xF3xima p\xE1gina",
    variant: "text",
    onClick: function onClick() {
      return handleChange(page + 1);
    },
    disabled: page === total,
    small: true
  }, /*#__PURE__*/_react["default"].createElement(ArrowRightIcon, null))), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_.IconButton, {
    "aria-label": "Ir para a \xFAltima pagina",
    variant: "text",
    onClick: function onClick() {
      return handleChange(total);
    },
    disabled: page === total,
    small: true
  }, /*#__PURE__*/_react["default"].createElement(SkipForwardIcon, null)))));
};

Pagination.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  page: _propTypes["default"].number.isRequired,
  total: _propTypes["default"].number.isRequired
};
var _default = Pagination;
exports["default"] = _default;